import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { IconButton, useTheme } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import { DIRECTIONS } from 'helpers/variables';
import { useIsDesktop } from 'components/utilities';

const ButtonGoBack = ({ path = '/' }) => {
	const { direction } = useTheme();

	const isDesktop = useIsDesktop();

	const fontSize = isDesktop ? 'large' : 'default';

	return (
		<IconButton component={Link} to={path} color="inherit">
			{direction === DIRECTIONS.LTR ? (
				<KeyboardArrowLeftIcon fontSize={fontSize} />
			) : (
				<KeyboardArrowRightIcon fontSize={fontSize} />
			)}
		</IconButton>
	);
};

ButtonGoBack.propTypes = {
	path: PropTypes.string,
};

export default ButtonGoBack;
